import { Card, type CardProps, Divider, Title } from '@mantine/core'

import { useTranslation } from '@flecto/translations'

import { FilterCategories } from './FilterCategories'
import { FilterContent } from './FilterContent'

export type CardFiltersProps = CardProps & {
  withCategories?: boolean
}

export function CardFilters({
  withCategories = true,
  ...props
}: CardFiltersProps) {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-product-list',
  })

  return (
    <Card display='block' {...props}>
      <Title order={5}>{t('label_filters')}</Title>
      <Divider my='md' color='gray.3' />
      <FilterContent mt='md' />
      {withCategories && <FilterCategories mt='md' />}
    </Card>
  )
}
